<template>
  <div>
      <div class="vx-row mb-6 ">
        <div class="vx-col w-15">
        <vs-select name='lengthChange' id='lengthChange' v-model="tableLength" label="Items per page" class="w-full">
            <vs-select-item key="5" value="5" text="5" />
            <vs-select-item key="10" value="10" text="10" />
            <vs-select-item key="20" value="20" text="20" />
            <vs-select-item key="-1" value="-1" text="All" />
        </vs-select>
        </div>
        <div class="vx-col w-20">
        <vs-input placeholder="Keyword" v-model="tableSearch" label="Search"/>
        </div>
    </div>
    <!-- <input id="searching"/> -->

    <slot name="table"></slot>
  </div>
</template>

<script>
import "datatables.net";
import defaults from "./defaults.js";
import { mapGetters } from "vuex";
import { API_BASE_URL } from "@/constants";

export default {
  name: "VhDatatables",
  props: {
    tableClass: String,
    config: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
        tableSearch: "",
        tableLength: 5
    };
  },
  watch: {
      tableLength(newVal, oldVal) {
          console.log(newVal, oldVal);
          var vm = this;
          $(vm.$el)
            .find("table")
            .DataTable().page.len(newVal).draw();
      },
      tableSearch(newVal, oldVal) {
          console.log(newVal, oldVal);
          var vm = this;
          $(vm.$el)
            .find("table")
            .DataTable().search(newVal).draw() ;
      }
  },
  created() {
    var r20 = /%20/g,
      rbracket = /\[\]$/,
      rCRLF = /\r?\n/g,
      rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
      rsubmittable = /^(?:input|select|textarea|keygen)/i;

    function customBuildParams(prefix, obj, traditional, add) {
      var name;

      if (jQuery.isArray(obj)) {
        // Serialize array item.
        jQuery.each(obj, function(i, v) {
          if (traditional || rbracket.test(prefix)) {
            // Treat each array item as a scalar.
            add(prefix, v);
          } else {
            // Item is non-scalar (array or object), encode its numeric
            // index.
            customBuildParams(
              prefix + "[" + (typeof v === "object" ? i : "") + "]",
              v,
              traditional,
              add
            );
          }
        });
      } else if (!traditional && jQuery.type(obj) === "object") {
        // Serialize object item.
        for (name in obj) {
          // This is where the magic happens
          customBuildParams(prefix + "." + name, obj[name], traditional, add);
        }
      } else {
        // Serialize scalar item.
        add(prefix, obj);
      }
    }

    $.param = function(a, traditional) {
      var prefix,
        s = [],
        add = function(key, value) {
          // If value is a function, invoke it and return its value
          value = jQuery.isFunction(value)
            ? value()
            : value == null
            ? ""
            : value;
          s[s.length] =
            encodeURIComponent(key) + "=" + encodeURIComponent(value);
        };

      // Set traditional to true for jQuery <= 1.3.2 behavior.
      if (traditional === undefined) {
        traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
      }

      // If an array was passed in, assume that it is an array of form
      // elements.
      if (jQuery.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
        // Serialize the form elements
        jQuery.each(a, function() {
          add(this.name, this.value);
        });
      } else {
        // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for (prefix in a) {
          customBuildParams(prefix, a[prefix], traditional, add);
        }
      }

      // Return the resulting serialization
      return s.join("&").replace(r20, "+");
    };
  },
  computed: {
    isLoaded() {
      return $.fn.dataTable.isDataTable($(this.$el).find("table"));
    }
  },
  methods: {
    init() {
      var vm = this;
      var VH_APP_CONTEXT = API_BASE_URL;
      var settings = $.extend({}, defaults, this.config);

      var nTable = $(this.$el).find("table");
      var columns = settings.columns;
      var dataUrl = settings.dataUrl;
      var colIndex = settings.columns.length;

      var table = nTable.DataTable({
        //"responsive": true,
        pageLength: 5,
        searching: true,
        lengthChange: false,
        ordering: true,
        order: [[0, "desc"]],
        processing: true,
        serverSide: true,
        // lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, "All"]],
        //"deferRender": true,
        bStateSave: true,
        fnStateSave: function(oSettings, oData) {
          localStorage.setItem(
            "DataTables_" + window.location.pathname,
            JSON.stringify(oData)
          );
        },
        fnStateLoad: function(oSettings) {
          return JSON.parse(
            localStorage.getItem("DataTables_" + window.location.pathname)
          );
        },
        ajax: {
          type: "GET",
          dataType: "json",
          url: dataUrl, // + ((dataUrl.indexOf('?') === -1) ? '?' : '&') + $.param(settings.customSearchParams),
          data: function(d) {
            vm.$emit(`event:onAjaxDataResponse`, d);
          }
        },
        columns: columns,
        pagingType: "full_numbers",
        rowGroup: {
          className: "tr-values vs-table--tr tr-table-state-null"
        },
        createdRow: function(row, data, dataIndex) {
          $(row).addClass("tr-values vs-table--tr tr-table-state-null");
        },
        drawCallback: function() {
          // $('.dataTables_paginate a').addClass('item-pagination');
        },
        columnDefs: [
          {
            targets: 0,
            className: "td-check"
          },
          {
            targets: colIndex + 0,
            className: "td vs-table--td",
            data: "id",
            render: function(data, type, row) {
              return '<a href="#" data-action="onClickView" class="vh-dt-view"> View </a>';
            }
          },
          {
            targets: colIndex + 1,
            data: "id",
            render: function(data, type, row) {
              return '<a href="#" data-action="onClickEdit" class="vh-dt-edit"> Edit </a>';
            }
          },
          {
            targets: colIndex + 2,
            data: "id",
            render: function(data, type, row) {
              return '<a href="#" data-action="onClickDelete" class="vh-dt-remove"> Delete </a>';
            }
          }
        ]
      });

        // $('#searching').keyup(function(){
        //     table.search($(this).val()).draw() ;
        // });

        // $('#lengthChange').change( function() { 
        //     table.page.len( $(this).val() ).draw();
        // });

    $("div.dataTables_filter").hide();
    //   /*
    //    * Reload button
    //    */
    //   $("div.dataTables_filter")
    //     .find("label")
    //     .html("<div></div>");
    //  $("<span>&nbsp;</span>").appendTo("div.dataTables_filter");

    //   var refreshBtn = $(
    //     '<button data-action="onClickRefresh" class="vs-component vs-button vs-button-primary vs-button-border small" >Refresh</button>'
    //   );
    //   refreshBtn.appendTo("div.dataTables_filter");
    //   refreshBtn.on("click", function(e) {
    //     settings.onClickRefresh();
    //     vm.refresh(true);
    //   });

    //   $("<span>&nbsp;</span>").appendTo("div.dataTables_filter");

    //   /*
    //    * Add button
    //    */
    //   var addBtn = $(
    //     '<button data-action="onClickAdd" class="vs-component vs-button vs-button-primary vs-button-border small" >&nbsp;Add New</button>'
    //   );
    //   addBtn.appendTo("div.dataTables_filter");
    },
    fetchData(from) {
      this.isLoaded &&
        $(this.$el)
          .find("table")
          .DataTable()
          .ajax.url(from)
          .load();
    },
    refresh(resetPaging) {
      this.isLoaded &&
        $(this.$el)
          .find("table")
          .DataTable()
          .ajax.reload(null, !!resetPaging);
    },
    bindClick() {
      let vm = this;
      $(vm.$el).on("click", "a, button", function(ev) {
        ev.preventDefault();

        let $btn = $(this);
        if ($btn.data("action")) {
          let rowData = $(vm.$el)
            .find("table")
            .DataTable()
            .row($btn.parents("tr"))
            .data();
          vm.$emit(`event:${$btn.data("action")}`, rowData, ev);
        }
      });
    },
    bindError() {
      let vm = this;
      // Disable default error mode (alert) from DataTables
      $.fn.dataTable.ext.errMode = "none";
      $(vm.$el)
        .find("table")
        .on("error.dt", (e, settings, techNote, message) => {
          vm.$emit("event:onError", { settings, techNote, message });
        });
    }
  },
  mounted() {
    this.init();
    this.bindClick();
    this.bindError();
  }
};
</script>

<style scoped language="scss">

.vs-table--tbody-table:nth-child(2n) {
  background: transparent;
}

</style>
